import React from 'react';

/**
 * Catches render errors from any descendant component (including i18n-related crashes)
 * and shows a friendly fallback with a Reload button. Without this, a thrown error
 * inside a translation call would render an entirely blank page.
 */
export default class SafeBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMsg: '' };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, errorMsg: error?.message || String(error) };
  }

  componentDidCatch(error, info) {
    // Log to console for debugging — production telemetry can be added later
    console.error('SafeBoundary caught:', error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#0f1117',
        padding: 20,
        fontFamily: 'Inter, system-ui, sans-serif',
        color: '#f0f2f8',
      }}>
        <div style={{
          maxWidth: 440,
          width: '100%',
          background: '#171b24',
          border: '1px solid #2a3044',
          borderRadius: 16,
          padding: '32px 28px',
          textAlign: 'center',
          boxShadow: '0 8px 24px rgba(0,0,0,.4)',
        }}>
          <div style={{ fontSize: 28, marginBottom: 12 }}>⚠️</div>
          <h2 style={{ fontSize: 17, fontWeight: 700, marginBottom: 8, letterSpacing: '-.02em' }}>
            Something went wrong / 出现问题
          </h2>
          <p style={{ fontSize: 13, color: '#b8bdd0', marginBottom: 18, lineHeight: 1.6 }}>
            The page couldn't be displayed. Try reloading.<br/>
            <span style={{ color: '#6b7394' }}>页面无法显示,请尝试重新加载。</span>
          </p>
          {this.state.errorMsg && (
            <div style={{
              fontFamily: 'JetBrains Mono, monospace',
              fontSize: 11,
              color: '#fca5a5',
              background: 'rgba(239,68,68,.1)',
              border: '1px solid rgba(239,68,68,.3)',
              padding: '8px 12px',
              borderRadius: 8,
              marginBottom: 16,
              wordBreak: 'break-word',
              textAlign: 'left',
            }}>
              {this.state.errorMsg}
            </div>
          )}
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '10px 20px',
              borderRadius: 8,
              border: 'none',
              background: '#3b82f6',
              color: 'white',
              fontWeight: 600,
              fontSize: 13,
              cursor: 'pointer',
              fontFamily: 'inherit',
            }}
          >
            Reload page / 重新加载
          </button>
        </div>
      </div>
    );
  }
}
